(function(){
    'use strict';
    //Rendo questo modulo sincrono restituendo un deferer per il rilascio esterno
    window.dcyAngular.internalDefine(function(){
            var dcyUtilsFactory 			= invokeAngularService('dcyUtilsFactory'),
                $q 							= invokeAngularService('$q'),
                deferred 					= $q.defer(),
            	applicationInfo 			= window.dcyAngular.SESSION_DATA.data.applicationInfo,
            	componentsJsTokanized 		= applicationInfo.jsToken  + applicationInfo.srcPath + applicationInfo.componentsPath,
            	jsLibPath					= applicationInfo.jsToken  + 'jsLib/',
	        	classesJsTokanized 			= jsLibPath  + 'classes/',
            	componentsCssTokanized  	= applicationInfo.cssToken + applicationInfo.srcPath + applicationInfo.componentsPath,
	            sectionsJsTokanized  		= applicationInfo.jsToken  + applicationInfo.srcPath + applicationInfo.sectionsPath,
            	templatesPathCssTokanized  	= applicationInfo.cssToken + applicationInfo.srcPath + applicationInfo.templatesPath,
            	templatesPathJsTokanized  	= applicationInfo.jsToken  + applicationInfo.srcPath + applicationInfo.templatesPath,
            	componentsVendorTokanized  	= applicationInfo.jsToken  + applicationInfo.vendorPath,

            	resourcesCss = resourcesCss = [
                    //CSS resources
                    componentsCssTokanized + 'navigation/breadcrumb/assets/css/breadcrumb.css',
                    componentsCssTokanized + 'navigation/list_nav/assets/css/list_nav.css',
                    componentsCssTokanized + 'draggable/assets/css/draggable.css',
                    componentsCssTokanized + 'droppable/assets/css/droppable.css',
                    componentsCssTokanized + 'dcy_menu/dcy_menu.css',
                    componentsCssTokanized + 'loading_spinner/dcy_loading_spinner.css'
                ],
                resourcesJs =  [
                              
                	 			/**### PROVIDERS ### */

                    			jsLibPath + 'bundles/contentsRest.js',
								classesJsTokanized 	  + 'data_managers/component_registry/component_registry_manager.class.es6.js',
								
								/**### METADATA ### */
								classesJsTokanized + 'metadata/cassiopea_types_enum.class.js',
								
								//Navigations Core Components
								componentsJsTokanized + 'navigation/navigation_manager.filters.js',
								componentsJsTokanized + 'navigation/navigation_manager_utils.factory.js',
								componentsJsTokanized + 'navigation/navigation_manager_status.factory.js',
								componentsJsTokanized + 'navigation/breadcrumb/breadcrumb.directive.js',
								componentsJsTokanized + 'navigation/list_nav/list_nav.directive.js',
								   
								//Menu Services Components
								classesJsTokanized + 'providers/editor_element/editor_element_data_provider_factory.class.js',
								componentsJsTokanized + 'content_menu/providers/common_menu_provider.factory.js',
								componentsJsTokanized + 'content_menu/content_menu_action_provider.factory.js',
								sectionsJsTokanized 	 + 'templateList/template_list_model.factory.js',
								sectionsJsTokanized   + 'templateList/catalogue_resources.factory.js',
								componentsJsTokanized + 'content_menu/providers/template_list/template_list_action.factory.js',
								
								
								//Menu Core Components
								componentsJsTokanized + 'dcy_menu/dcy_menu_types.constant.js',
								componentsJsTokanized + 'dcy_menu/dcy_menu_options.service.js',
								componentsJsTokanized + 'dcy_menu/dcy_menu.factory.js',
								   
								componentsVendorTokanized + 'ng-file-upload/ng-file-upload.js',
								componentsVendorTokanized + 'angular-img-cropper/dist/angular-img-cropper.min.js',
								componentsJsTokanized + 'form/dcy_form.factory.js',
								componentsJsTokanized + 'form/dcy_form_component.directive.js',
								
								/**### DATA MANAGERS ### */
								classesJsTokanized + 'data_managers/loaders/loader_presets_enum.class.es6.js',
								classesJsTokanized + 'data_managers/loaders/loaders_manager.class.es6.js',
								componentsJsTokanized + 'loading_spinner/loader.class.es6.js',
								componentsJsTokanized + 'loading_spinner/dcy_loading_spinner.directive.js',
								classesJsTokanized + 'data_managers/editor_element/editor_element_data_manager.class.js',
								
								templatesPathJsTokanized + 'Main/LandingPage/landingPage_BaseTMPL.res/landingPage.factory.js'
								
                                ];

            dcyUtilsFactory.resolveDependencies(resourcesCss, '', function(){});
            
            dcyUtilsFactory.resolveDependencies(resourcesJs, '', function(){
            	DECISYON.ng.register.module(['ngFileUpload', 'angular-img-cropper']);
            	deferred.resolve();
            }, function(){
            	deferred.reject();
            });

        	return deferred.promise;
    });
}());